import React, { useEffect, useState } from "react";
import { db } from "../../config/firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { toast } from "react-toastify";
import { useMyContext } from "../../context/MyContext";
import { Tooltip } from "antd";
import { useQueryClient } from "@tanstack/react-query";
import HistoryIcon from "./History";
import { api } from "../../config/api";
import { getSettings } from "../../lib/setting";

const UpdateQuoteNumber = () => {
  const { user } = useMyContext();
  const queryClient = useQueryClient();
  const [formData, setFormData] = useState({
    quoteNumber_Prefix: "",
  });
  const [initialValue, setInitialValue] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getSettings();
        setFormData(data);
        setInitialValue(data.quoteNumber_Prefix || "");
      } catch (error) {
        console.error("Error fetching settings data:", error);
        toast.error("Error fetching settings data. Please try again later.");
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleAddData = async () => {
    try {
      const nextQuoteNumberPrefix = String(formData.quoteNumber_Prefix || "").trim();

      if (!nextQuoteNumberPrefix) {
        toast.error("Quote number prefix is required");
        return;
      }

      // Only proceed if the value has changed
      if (initialValue !== nextQuoteNumberPrefix) {
        await api.patch("/firestore/settings", {
          quoteNumber_Prefix: nextQuoteNumberPrefix,
        });
        
        // Add to history collection
        const historyCollectionRef = collection(db, "prefixHistory");
        await addDoc(historyCollectionRef, {
          prefixType: "Quote Number Prefix",
          oldValue: initialValue,
          newValue: nextQuoteNumberPrefix,
          updatedBy: user?.name || user?.email || "Unknown user",
          updatedById: user?.uid,
          timestamp: serverTimestamp()
        });
        
        // Update the initial value to the new value
        setInitialValue(nextQuoteNumberPrefix);
        setFormData((prevData) => ({
          ...prevData,
          quoteNumber_Prefix: nextQuoteNumberPrefix,
        }));
        
        // Invalidate and refetch the settings query to force update
        queryClient.invalidateQueries(['settings']);
        queryClient.invalidateQueries(['quotes']);
        
        toast.success("Quote number prefix updated successfully!");
      } else {
        toast.info("No changes detected");
      }
    } catch (error) {
      console.error("Error updating quote number prefix:", error);
      toast.error(error?.response?.data?.error || "Error updating quote number prefix. Please try again later.");
    }
  };

  return (
    <div>
      <div className="w-full">
        <div className="flex flex-col gap-1 py-2">
          <div className="flex items-center justify-between">
            <label
              className="w-full text-sm font-normal"
              htmlFor="quoteNumberPrefix"
            >
              Quote Number Prefix Update
            </label>
            <HistoryIcon prefixType="Quote Number Prefix" />
          </div>
          <input
            type="text"
            placeholder="Quote Number Prefix"
            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
            id="quoteNumber_Prefix"
            onChange={handleInputChange}
            value={formData.quoteNumber_Prefix}
            name="quoteNumber_Prefix"
            disabled={user?.role === "super admin" ? false : true}
          />
        </div>
        <Tooltip
          title={
            user?.role === "super admin"
              ? ""
              : "You cannot edit it in your current role"
          }
        >
          <button
            onClick={handleAddData}
            className={`px-8 py-2 rounded-lg text-sm text-[#fff] ${
              user?.role === "super admin"
                ? "bg-[#03336E]"
                : "cursor-not-allowed bg-gray-300"
            }`}
            disabled={user?.role === "super admin" ? false : true}
          >
            Update Quote No
          </button>
        </Tooltip>
      </div>
    </div>
  );
};

export default UpdateQuoteNumber;
